import { useCallback } from 'react'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'

interface UseSwitchAccountOptions {
  oldIntegration: ExternalIntegration
}

/**
 * Hook that provides a connect function to switch from one account to another (same provider).
 * Passes the old integration ID to the API so it can handle deletion and other logic.
 */
export const useSwitchAccount = ({ oldIntegration }: UseSwitchAccountOptions) => {
  const { connect: originalConnect } = useConnectAccountPopup()

  const connect = useCallback(
    async (popup: Window | undefined, options?: any) => {
      // Pass the old integration ID through options so it can be sent to the API
      const wrappedOptions = {
        ...options,
        switchFromIntegrationId: oldIntegration.id,
      }
      // Also merge switchFromIntegrationId from options if it exists (for WordPress flow)
      if (options?.switchFromIntegrationId) {
        wrappedOptions.switchFromIntegrationId = options.switchFromIntegrationId
      }
      return originalConnect(popup, wrappedOptions)
    },
    [originalConnect, oldIntegration.id],
  )

  return {
    connect,
  }
}
